// DOC-DEPS: LLM.md -> docs/Seeday_植物生长_PRD_v1_8.docx -> docs/Seeday_植物生长_技术实现文档_v1.7.docx

export type RootType = 'tap' | 'fib' | 'sha' | 'bra' | 'bul';

// 植物生长阶段：只有早期和晚期，已移除 mid
export type PlantStage = 'early' | 'late';

export type DirectionIndex = 0 | 1 | 2 | 3 | 4;

export type FocusLevel = 'medium' | 'high';

export type PlantCategoryKey = 'entertainment' | 'social' | 'work_study' | 'exercise' | 'life';

export const DEFAULT_DIRECTION_ORDER: PlantCategoryKey[] = [
  'entertainment',
  'social',
  'work_study',
  'exercise',
  'life',
];

export interface DirectionBreakdownItem {
  minutes: number;
  weightedMinutes: number;
  activities: number;
  focus: FocusLevel;
}

export interface RootMetrics {
  dominantRatio: number;
  top2Gap: number;
  depthScore: number;
  evenness: number;
  branchiness: number;
  totalMinutes: number;
  activeTargetDirections: number;
  directionBreakdown: Partial<Record<PlantCategoryKey, DirectionBreakdownItem>>;
}

export interface PlantRootSnapshotActivity {
  id: string;
  content: string;
  activityType?: string | null;
  timestamp: number;
  categoryKey: PlantCategoryKey;
  minutes: number;
  focus: FocusLevel;
}

export interface PlantRootSnapshot {
  directionOrder: PlantCategoryKey[];
  segments: RootSegment[];
  activities: PlantRootSnapshotActivity[];
}

export interface DailyPlantRecord {
  id: string;
  userId: string;
  date: string;
  timezone: string;
  rootMetrics: RootMetrics;
  rootType: RootType;
  plantId: string;
  plantStage: PlantStage;
  isSpecial: boolean;
  isSupportVariant: boolean;
  diaryText?: string;
  rootSnapshot?: PlantRootSnapshot;
  generatedAt: number;
  cycleId?: string | null;
}

export interface RootSegment {
  id: string;
  direction: DirectionIndex;
  activityId: string;
  minutes: number;
  focus: FocusLevel;
  isMainRoot: boolean;
  branchOrder: number;
  growthMode?: 'origin' | 'branch';
  branchRatio?: number;
  parentRootId?: string;
}

export type PlantApiStatus = 'too_early' | 'empty_day' | 'generated' | 'already_generated' | 'monthly_exhausted';

export interface PlantGenerateRequest {
  date: string;
  timezone: string;
  action?: 'generate' | 'snapshot_existing';
  dayStartMs?: number;
  dayEndMs?: number;
  lang?: 'zh' | 'en' | 'it';
}

export interface PlantDiaryRequest {
  date: string;
  activities: Array<{ category: PlantCategoryKey; duration: number; focus: FocusLevel }>;
  totalDuration: number;
  rootType: RootType;
  plantStage: PlantStage;
  isSpecial: boolean;
  isSupportVariant?: boolean;
  lang?: 'zh' | 'en' | 'it';
}

export interface PlantDiaryResponse {
  success: boolean;
  diaryText: string;
  diaryStatus: 'ready' | 'fallback';
}

export interface PlantGenerateResponse {
  success: boolean;
  status: PlantApiStatus;
  plant: DailyPlantRecord | null;
  message?: string;
  diaryStatus?: 'ready' | 'fallback';
}

export interface PlantHistoryResponse {
  success: boolean;
  records: DailyPlantRecord[];
}

export interface PlantAssetTelemetryRequest {
  requestedPlantId: string;
  resolvedAssetUrl: string;
  fallbackLevel: 1 | 2 | 3 | 4;
  rootType: RootType;
  plantStage: PlantStage;
  lang?: 'zh' | 'en' | 'it';
}

export interface PlantAssetTelemetryResponse {
  success: boolean;
  id?: string;
  skipped?: boolean;
}

export interface PlantDirectionConfig {
  id: string;
  userId: string;
  directionIndex: DirectionIndex;
  categoryKey: PlantCategoryKey;
  updatedAt: number;
}
